import { getButtonRowStarter } from './button-row';
import { starterChild } from './slot';
import type { StarterChild } from './slot';

export type TileStarterChild =
  | StarterChild
  | {
      type: 'ButtonRow';
      props: { content: StarterChild[]; desktopLayout: 'row'; mobileLayout: 'column' };
    };

/**
 * The complete slot tree every newly inserted or pre-seeded Tile starts with: a Heading, a Text
 * block and a Button row (two Buttons). Authors can edit, reorder, remove or add to these.
 *
 * IDs are intentionally absent at every level. Puck recursively stamps fresh IDs when a Tile is
 * inserted, including the Tiles Grid Layout seeds by default. Every call returns fresh objects so
 * no two Tiles share (and mutate) the same children.
 */
export function getTileStarterChildren(): TileStarterChild[] {
  return [
    // preset: 'level' means "use level's own default size" (HeadingProps.preset is 'level' |
    // 'custom', not a heading level like 'h3' -- that's what `level` itself is for).
    starterChild('Heading', { text: '<p>Your tile title</p>', level: 'h3', preset: 'level' }),
    starterChild('Paragraph', { text: '<p>Add a short description that supports your title.</p>' }),
    {
      type: 'ButtonRow',
      props: {
        content: getButtonRowStarter(),
        desktopLayout: 'row',
        mobileLayout: 'column',
      },
    },
  ];
}
